<template>
  <div class="crewHome">
    <div class="crewHome-content" style="overflow: auto">
      <el-form :inline="true" :model="formInline" class="other-form-left">
        <el-form-item label="船舶:" style="margin-left: 10px">
          <el-input
            v-model="labList.shipName"
            style="width: 100px"
            :readonly="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="月份:">
          <el-input
            v-model="labList.month"
            style="width: 100px"
            :readonly="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="美元汇率:">
          <el-input
            v-model="labList.usdcny"
            style="width: 100px"
            :readonly="true"
          ></el-input>
        </el-form-item>
      </el-form>
      <el-form :inline="true" :model="formInline" class="other-form-inline">
        <el-form-item>
          <el-input
            v-model="formInline.userName"
            placeholder="船员姓名"
            style="width: 150px"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="formInline.postName"
            placeholder="职务"
            style="width: 150px"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <div class="other-search" @click="onSubmit">
            <i class="el-icon-search"></i>
          </div>
        </el-form-item>
        <el-form-item>
          <div class="other-search3" @click="exportExcel()">导出</div>
        </el-form-item>
      </el-form>
      <div style="clear: both"></div>
      <el-divider class="other-divider"></el-divider>
      <div class="table-salary table-costDetail">
        <el-table
          :data="tableData"
          style="width: 100%"
          show-summary
          header-row-class-name="other-header"
          row-class-name="other-row"
          height="100%"
        >
          <el-table-column
            prop="userName"
            label="船员姓名"
            min-width="100"
            fixed
          >
          </el-table-column>
          <el-table-column prop="postName" label="职务" min-width="80" fixed>
          </el-table-column>
          <el-table-column prop="" label="船员类型" min-width="150" fixed>
            <template slot-scope="scope">
              <!-- <span>{{
                scope.row.crewType == 1
                  ? "自有船员"
                  : scope.row.crewType == 2
                  ? "外包船员"
                  : ""
              }}</span> -->
              <div v-if="type == '1'">
                <span v-if="scope.row.crewType == '1'">自有船员</span>
                <span v-if="scope.row.crewType == '2'">外包船员</span>
                <span v-if="scope.row.crewType == '3'">船货代船员</span>
              </div>
              <div v-if="type == '2'">
                <el-select v-model="scope.row.crewType" @change="changeType(scope.row)" placeholder="船员类型">
                  <el-option label="自有船员" value="1"></el-option>
                  <el-option label="外包船员" value="2"></el-option>
                  <el-option label="船货代船员" value="3"></el-option>
                </el-select>
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="sex" label="船舶名称" min-width="80">
          </el-table-column> -->
          <el-table-column
            prop="overLimitContainerFee"
            label="冷、危、超 限箱费"
            min-width="100"
          >
            <template slot-scope="scope">
              <el-tooltip
                v-if="type == '1'"
                popper-class="center"
                effect="dark"
                :content="scope.row.overLimitContainerTitle"
                placement="top"
              >
                <el-button class="cost-button" style="border: none">
                  <span class="ov-green">{{
                    scope.row.overLimitContainerFeeCompy
                  }}</span>
                  <span
                    v-if="
                      scope.row.overLimitContainerFeeCompy ||
                      scope.row.overLimitContainerFeeCompy == '0'
                    "
                    >/</span
                  ><span class="ov-orange">{{
                    scope.row.overLimitContainerFeeLabor
                  }}</span>
                  <span
                    v-if="
                      scope.row.overLimitContainerFeeLabor ||
                      scope.row.overLimitContainerFeeLabor == '0'
                    "
                    >/</span
                  ><span>{{ scope.row.overLimitContainerFeeInit }}</span>
                </el-button>
              </el-tooltip>
              <div v-if="type == '2'">
                <el-input
                  v-model="scope.row.overLimitContainerFee"
                  @change="moneyChange(scope.row)"
                  oninput="value=value.replace(/^\./g, '').replace(/[^\d.]/g,'').replace(/\.{2,}/g,'')"
                  size="mini"
                  class="cost-input"
                  placeholder="请输入"
                ></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="terminalSelfGuidedFee"
            label="自引航费"
            min-width="100"
          >
            <template slot-scope="scope">
              <el-tooltip
                v-if="type == '1'"
                popper-class="center"
                effect="dark"
                :content="scope.row.terminalSelfGuidedTitle"
                placement="top"
              >
                <el-button class="cost-button" style="border: none">
                  <span class="ov-green">{{
                    scope.row.terminalSelfGuidedFeeCompy
                  }}</span>
                  <span
                    v-if="
                      scope.row.terminalSelfGuidedFeeCompy ||
                      scope.row.terminalSelfGuidedFeeCompy == '0'
                    "
                    >/</span
                  ><span class="ov-orange">{{
                    scope.row.terminalSelfGuidedFeeLabor
                  }}</span>
                  <span
                    v-if="
                      scope.row.terminalSelfGuidedFeeLabor ||
                      scope.row.terminalSelfGuidedFeeLabor == '0'
                    "
                    >/</span
                  ><span>{{ scope.row.terminalSelfGuidedFeeInit }}</span>
                </el-button>
              </el-tooltip>
              <div v-if="type == '2'">
                <el-input
                  v-model="scope.row.terminalSelfGuidedFee"
                  @change="moneyChange(scope.row)"
                  oninput="value=value.replace(/^\./g, '').replace(/[^\d.]/g,'').replace(/\.{2,}/g,'')"
                  size="mini"
                  class="cost-input"
                  placeholder="请输入"
                ></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="berthingFee" label="靠离泊费" min-width="100">
            <template slot-scope="scope">
              <el-tooltip
                v-if="type == '1'"
                popper-class="center"
                effect="dark"
                :content="scope.row.berthingTitle"
                placement="top"
              >
                <el-button class="cost-button" style="border: none">
                  <span class="ov-green">{{ scope.row.berthingFeeCompy }}</span>
                  <span
                    v-if="
                      scope.row.berthingFeeCompy ||
                      scope.row.berthingFeeCompy == '0'
                    "
                    >/</span
                  ><span class="ov-orange">{{
                    scope.row.berthingFeeLabor
                  }}</span>
                  <span
                    v-if="
                      scope.row.berthingFeeLabor ||
                      scope.row.berthingFeeLabor == '0'
                    "
                    >/</span
                  ><span>{{ scope.row.berthingFeeInit }}</span>
                </el-button>
              </el-tooltip>
              <div v-if="type == '2'">
                <el-input
                  v-model="scope.row.berthingFee"
                  @change="moneyChange(scope.row)"
                  oninput="value=value.replace(/^\./g, '').replace(/[^\d.]/g,'').replace(/\.{2,}/g,'')"
                  size="mini"
                  class="cost-input"
                  placeholder="请输入"
                ></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="inlandSeaNavigationFee"
            label="内海航行"
            min-width="100"
          >
            <template slot-scope="scope">
              <el-tooltip
                v-if="type == '1'"
                popper-class="center"
                effect="dark"
                :content="scope.row.inlandSeaNavigationTitle"
                placement="top"
              >
                <el-button class="cost-button" style="border: none">
                  <span class="ov-green">{{
                    scope.row.inlandSeaNavigationFeeCompy
                  }}</span>
                  <span
                    v-if="
                      scope.row.inlandSeaNavigationFeeCompy ||
                      scope.row.inlandSeaNavigationFeeCompy == '0'
                    "
                    >/</span
                  ><span class="ov-orange">{{
                    scope.row.inlandSeaNavigationFeeLabor
                  }}</span>
                  <span
                    v-if="
                      scope.row.inlandSeaNavigationFeeLabor ||
                      scope.row.inlandSeaNavigationFeeLabor == '0'
                    "
                    >/</span
                  ><span>{{ scope.row.inlandSeaNavigationFeeInit }}</span>
                </el-button>
              </el-tooltip>
              <div v-if="type == '2'">
                <el-input
                  v-model="scope.row.inlandSeaNavigationFee"
                  @change="moneyChange(scope.row)"
                  oninput="value=value.replace(/^\./g, '').replace(/[^\d.]/g,'').replace(/\.{2,}/g,'')"
                  size="mini"
                  class="cost-input"
                  placeholder="请输入"
                ></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="serviceFee" label="业务费" min-width="100">
            <template slot-scope="scope">
              <el-tooltip
                v-if="type == '1'"
                popper-class="center"
                effect="dark"
                :content="scope.row.serviceTitle"
                placement="top"
              >
                <el-button class="cost-button" style="border: none">
                  <span class="ov-green">{{ scope.row.serviceFeeCompy }}</span>
                  <span
                    v-if="
                      scope.row.serviceFeeCompy ||
                      scope.row.serviceFeeCompy == '0'
                    "
                    >/</span
                  ><span class="ov-orange">{{
                    scope.row.serviceFeeLabor
                  }}</span>
                  <span
                    v-if="
                      scope.row.serviceFeeLabor ||
                      scope.row.serviceFeeLabor == '0'
                    "
                    >/</span
                  ><span>{{ scope.row.serviceFeeInit }}</span>
                </el-button>
              </el-tooltip>
              <div v-if="type == '2'">
                <el-input
                  v-model="scope.row.serviceFee"
                  @change="moneyChange(scope.row)"
                  oninput="value=value.replace(/^\./g, '').replace(/[^\d.]/g,'').replace(/\.{2,}/g,'')"
                  size="mini"
                  class="cost-input"
                  placeholder="请输入"
                ></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="cabinCleaningFeeDollar" label="洗舱费">
            <template slot-scope="scope">
              <el-tooltip
                v-if="type == '1'"
                popper-class="center"
                effect="dark"
                :content="scope.row.cabinCleaningFeeDollarTitle"
                placement="top"
              >
                <el-button class="cost-button" style="border: none">
                  <span class="ov-green">{{
                    scope.row.cabinCleaningFeeDollarCompy
                  }}</span>
                  <span
                    v-if="
                      scope.row.cabinCleaningFeeDollarCompy ||
                      scope.row.cabinCleaningFeeDollarCompy == '0'
                    "
                    >/</span
                  ><span class="ov-orange">{{
                    scope.row.cabinCleaningFeeDollarLabor
                  }}</span>
                  <span
                    v-if="
                      scope.row.cabinCleaningFeeDollarLabor ||
                      scope.row.cabinCleaningFeeDollarLabor == '0'
                    "
                    >/</span
                  ><span>{{ scope.row.cabinCleaningFeeDollarInit }}</span>
                </el-button>
              </el-tooltip>
              <div v-if="type == '2'">
                <el-input
                  @change="moneyChange(scope.row)"
                  v-model="scope.row.cabinCleaningFeeDollar"
                  oninput="value=value.replace(/^\./g, '').replace(/[^\d.]/g,'').replace(/\.{2,}/g,'')"
                  size="mini"
                  class="cost-input"
                  placeholder="请输入"
                ></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="voyageFeeDollar" label="航次费">
            <template slot-scope="scope">
              <el-tooltip
                v-if="type == '1'"
                popper-class="center"
                effect="dark"
                :content="scope.row.voyageFeeDollarTitle"
                placement="top"
              >
                <el-button class="cost-button" style="border: none">
                  <span class="ov-green">{{
                    scope.row.voyageFeeDollarCompy
                  }}</span>
                  <span
                    v-if="
                      scope.row.voyageFeeDollarCompy ||
                      scope.row.voyageFeeDollarCompy == '0'
                    "
                    >/</span
                  ><span class="ov-orange">{{
                    scope.row.voyageFeeDollarLabor
                  }}</span>
                  <span
                    v-if="
                      scope.row.voyageFeeDollarLabor ||
                      scope.row.voyageFeeDollarLabor == '0'
                    "
                    >/</span
                  ><span>{{ scope.row.voyageFeeDollarInit }}</span>
                </el-button>
              </el-tooltip>
              <div v-if="type == '2'">
                <el-input
                  @change="moneyChange(scope.row)"
                  v-model="scope.row.voyageFeeDollar"
                  oninput="value=value.replace(/^\./g, '').replace(/[^\d.]/g,'').replace(/\.{2,}/g,'')"
                  size="mini"
                  class="cost-input"
                  placeholder="请输入"
                ></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="constantFeeDollar" label="常数费">
            <template slot-scope="scope">
              <el-tooltip
                v-if="type == '1'"
                popper-class="center"
                effect="dark"
                :content="scope.row.constantFeeDollarTitle"
                placement="top"
              >
                <el-button class="cost-button" style="border: none">
                  <span class="ov-green">{{
                    scope.row.constantFeeDollarCompy
                  }}</span>
                  <span
                    v-if="
                      scope.row.constantFeeDollarCompy ||
                      scope.row.constantFeeDollarCompy == '0'
                    "
                    >/</span
                  ><span class="ov-orange">{{
                    scope.row.constantFeeDollarLabor
                  }}</span>
                  <span
                    v-if="
                      scope.row.constantFeeDollarLabor ||
                      scope.row.constantFeeDollarLabor == '0'
                    "
                    >/</span
                  ><span>{{ scope.row.constantFeeDollarInit }}</span>
                </el-button>
              </el-tooltip>
              <div v-if="type == '2'">
                <el-input
                  @change="moneyChange(scope.row)"
                  v-model="scope.row.constantFeeDollar"
                  oninput="value=value.replace(/^\./g, '').replace(/[^\d.]/g,'').replace(/\.{2,}/g,'')"
                  size="mini"
                  class="cost-input"
                  placeholder="请输入"
                ></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="lclHandlingUsdFee" label="外贸散货业务费">
            <template slot-scope="scope">
              <el-tooltip
                v-if="type == '1'"
                popper-class="center"
                effect="dark"
                :content="scope.row.lclHandlingUsdFeeTitle"
                placement="top"
              >
                <el-button class="cost-button" style="border: none">
                  <span class="ov-green">{{
                    scope.row.constantFeeDollarCompy
                  }}</span>
                  <span
                    v-if="
                      scope.row.lclHandlingUsdFeeCompy ||
                      scope.row.lclHandlingUsdFeeCompy == '0'
                    "
                    >/</span
                  ><span class="ov-orange">{{
                    scope.row.lclHandlingUsdFeeLabor
                  }}</span>
                  <span
                    v-if="
                      scope.row.lclHandlingUsdFeeLabor ||
                      scope.row.lclHandlingUsdFeeLabor == '0'
                    "
                    >/</span
                  ><span>{{ scope.row.lclHandlingUsdFeeInit }}</span>
                </el-button>
              </el-tooltip>
              <div v-if="type == '2'">
                <el-tooltip
                  v-if="
                    scope.row.lclHandlingUsdFeeLabor ||
                    scope.row.lclHandlingUsdFeeLabor == '0'
                  "
                  popper-class="center"
                  effect="dark"
                  :content="scope.row.lclHandlingUsdFeeTitle"
                  placement="top"
                >
                  <el-input
                    @change="moneyChange(scope.row)"
                    v-model="scope.row.lclHandlingUsdFee"
                    oninput="value=value.replace(/^\./g, '').replace(/[^\d.]/g,'').replace(/\.{2,}/g,'')"
                    size="mini"
                    class="cost-input red-input"
                    placeholder="请输入"
                  ></el-input>
                </el-tooltip>
                <el-input
                  @change="moneyChange(scope.row)"
                  v-if="
                    !scope.row.lclHandlingUsdFeeLabor &&
                    scope.row.lclHandlingUsdFeeLabor != '0'
                  "
                  v-model="scope.row.lclHandlingUsdFee"
                  oninput="value=value.replace(/^\./g, '').replace(/[^\d.]/g,'').replace(/\.{2,}/g,'')"
                  size="mini"
                  class="cost-input"
                  placeholder="请输入"
                ></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="antiPiracyBonus" label="防海盗奖励">
            <template slot-scope="scope">
              <el-tooltip
                v-if="type == '1'"
                popper-class="center"
                effect="dark"
                :content="scope.row.antiPiracyBonusTitle"
                placement="top"
              >
                <el-button class="cost-button" style="border: none">
                  <span class="ov-green">{{
                    scope.row.antiPiracyBonusCompy
                  }}</span>
                  <span
                    v-if="
                      scope.row.antiPiracyBonusCompy ||
                      scope.row.antiPiracyBonusCompy == '0'
                    "
                    >/</span
                  ><span class="ov-orange">{{
                    scope.row.antiPiracyBonusLabor
                  }}</span>
                  <span
                    v-if="
                      scope.row.antiPiracyBonusLabor ||
                      scope.row.antiPiracyBonusLabor == '0'
                    "
                    >/</span
                  ><span>{{ scope.row.antiPiracyBonusInit }}</span>
                </el-button>
              </el-tooltip>
              <div v-if="type == '2'">
                <el-tooltip
                  v-if="
                    scope.row.antiPiracyBonusLabor ||
                    scope.row.antiPiracyBonusLabor == '0'
                  "
                  popper-class="center"
                  effect="dark"
                  :content="scope.row.antiPiracyBonusTitle"
                  placement="top"
                >
                  <el-input
                    @change="moneyChange(scope.row)"
                    v-model="scope.row.antiPiracyBonus"
                    oninput="value=value.replace(/^\./g, '').replace(/[^\d.]/g,'').replace(/\.{2,}/g,'')"
                    size="mini"
                    class="cost-input red-input"
                    placeholder="请输入"
                  ></el-input>
                </el-tooltip>
                <el-input
                  @change="moneyChange(scope.row)"
                  v-if="
                    !scope.row.antiPiracyBonusLabor &&
                    scope.row.antiPiracyBonusLabor != '0'
                  "
                  v-model="scope.row.antiPiracyBonus"
                  oninput="value=value.replace(/^\./g, '').replace(/[^\d.]/g,'').replace(/\.{2,}/g,'')"
                  size="mini"
                  class="cost-input"
                  placeholder="请输入"
                ></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="usdSubTotal" label="美元小计" min-width="100">
            <template slot-scope="scope">
              <el-tooltip
                v-if="type == '1'"
                popper-class="center"
                effect="dark"
                :content="scope.row.usdSubTotalTitle"
                placement="top"
              >
                <el-button class="cost-button" style="border: none">
                  <span class="ov-green">{{ scope.row.usdSubTotalCompy }}</span>
                  <span
                    v-if="
                      scope.row.usdSubTotalCompy ||
                      scope.row.usdSubTotalCompy == '0'
                    "
                    >/</span
                  ><span class="ov-orange">{{
                    scope.row.usdSubTotalLabor
                  }}</span>
                  <span
                    v-if="
                      scope.row.usdSubTotalLabor ||
                      scope.row.usdSubTotalLabor == '0'
                    "
                    >/</span
                  ><span>{{ scope.row.usdSubTotalInit }}</span>
                </el-button>
              </el-tooltip>
              <div v-if="type == '2'">
                {{ scope.row.usdSubTotal }}
                <!-- <el-input
                  v-model="scope.row.usdSubTotal"
                  oninput="value=value.replace(/^\./g, '').replace(/[^\d.]/g,'').replace(/\.{2,}/g,'')"
                  size="mini"
                  class="cost-input"
                  placeholder="请输入"
                ></el-input> -->
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="inviteTime" label="美元汇率" min-width="100">
          </el-table-column> -->
          <el-table-column
            prop="selfRepairMaintenanceFee"
            label="自修保养费"
            min-width="100"
          >
            <template slot-scope="scope">
              <el-tooltip
                v-if="type == '1'"
                popper-class="center"
                effect="dark"
                :content="scope.row.selfRepairMaintenanceTitle"
                placement="top"
              >
                <el-button class="cost-button" style="border: none">
                  <span class="ov-green">{{
                    scope.row.selfRepairMaintenanceFeeCompy
                  }}</span>
                  <span
                    v-if="
                      scope.row.selfRepairMaintenanceFeeCompy ||
                      scope.row.selfRepairMaintenanceFeeCompy == '0'
                    "
                    >/</span
                  ><span class="ov-orange">{{
                    scope.row.selfRepairMaintenanceFeeLabor
                  }}</span>
                  <span
                    v-if="
                      scope.row.selfRepairMaintenanceFeeLabor ||
                      scope.row.selfRepairMaintenanceFeeLabor == '0'
                    "
                    >/</span
                  ><span>{{ scope.row.selfRepairMaintenanceFeeInit }}</span>
                </el-button>
              </el-tooltip>
              <div v-if="type == '2'">
                <el-input
                  @change="moneyChange(scope.row)"
                  v-model="scope.row.selfRepairMaintenanceFee"
                  oninput="value=value.replace(/^\./g, '').replace(/[^\d.]/g,'').replace(/\.{2,}/g,'')"
                  size="mini"
                  class="cost-input"
                  placeholder="请输入"
                ></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="checkRewards" label="检查奖励" min-width="100">
            <template slot-scope="scope">
              <el-tooltip
                v-if="type == '1'"
                popper-class="center"
                effect="dark"
                :content="scope.row.checkRewardsTitle"
                placement="top"
              >
                <el-button class="cost-button" style="border: none">
                  <span class="ov-green">{{
                    scope.row.checkRewardsCompy
                  }}</span>
                  <span
                    v-if="
                      scope.row.checkRewardsCompy ||
                      scope.row.checkRewardsCompy == '0'
                    "
                    >/</span
                  ><span class="ov-orange">{{
                    scope.row.checkRewardsLabor
                  }}</span>
                  <span
                    v-if="
                      scope.row.checkRewardsLabor ||
                      scope.row.checkRewardsLabor == '0'
                    "
                    >/</span
                  ><span>{{ scope.row.checkRewardsInit }}</span>
                </el-button>
              </el-tooltip>
              <div v-if="type == '2'">
                <el-input
                  @change="moneyChange(scope.row)"
                  v-model="scope.row.checkRewards"
                  oninput="value=value.replace(/^\./g, '').replace(/[^\d.]/g,'').replace(/\.{2,}/g,'')"
                  size="mini"
                  class="cost-input"
                  placeholder="请输入"
                ></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="tyingFee" label="绑扎费" min-width="100">
            <template slot-scope="scope">
              <el-tooltip
                v-if="type == '1'"
                popper-class="center"
                effect="dark"
                :content="scope.row.tyingFeeTitle"
                placement="top"
              >
                <el-button class="cost-button" style="border: none">
                  <span class="ov-green">{{ scope.row.tyingFeeCompy }}</span>
                  <span
                    v-if="
                      scope.row.tyingFeeCompy || scope.row.tyingFeeCompy == '0'
                    "
                    >/</span
                  ><span class="ov-orange">{{ scope.row.tyingFeeLabor }}</span>
                  <span
                    v-if="
                      scope.row.tyingFeeLabor || scope.row.tyingFeeLabor == '0'
                    "
                    >/</span
                  ><span>{{ scope.row.tyingFeeInit }}</span>
                </el-button>
              </el-tooltip>
              <div v-if="type == '2'">
                <el-input
                  @change="moneyChange(scope.row)"
                  v-model="scope.row.tyingFee"
                  oninput="value=value.replace(/^\./g, '').replace(/[^\d.]/g,'').replace(/\.{2,}/g,'')"
                  size="mini"
                  class="cost-input"
                  placeholder="请输入"
                ></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="selfPilotingFee"
            label="自引航费"
            min-width="100"
          >
            <template slot-scope="scope">
              <el-tooltip
                v-if="type == '1'"
                popper-class="center"
                effect="dark"
                :content="scope.row.selfPilotingTitle"
                placement="top"
              >
                <el-button class="cost-button" style="border: none">
                  <span class="ov-green">{{
                    scope.row.selfPilotingFeeCompy
                  }}</span>
                  <span
                    v-if="
                      scope.row.selfPilotingFeeCompy ||
                      scope.row.selfPilotingFeeCompy == '0'
                    "
                    >/</span
                  ><span class="ov-orange">{{
                    scope.row.selfPilotingFeeLabor
                  }}</span>
                  <span
                    v-if="
                      scope.row.selfPilotingFeeLabor ||
                      scope.row.selfPilotingFeeLabor == '0'
                    "
                    >/</span
                  ><span>{{ scope.row.selfPilotingFeeInit }}</span>
                </el-button>
              </el-tooltip>
              <div v-if="type == '2'">
                <el-input
                  @change="moneyChange(scope.row)"
                  v-model="scope.row.selfPilotingFee"
                  oninput="value=value.replace(/^\./g, '').replace(/[^\d.]/g,'').replace(/\.{2,}/g,'')"
                  size="mini"
                  class="cost-input"
                  placeholder="请输入"
                ></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="cabinCleaningFee"
            label="洗舱费"
            min-width="100"
          >
            <template slot-scope="scope">
              <el-tooltip
                v-if="type == '1'"
                popper-class="center"
                effect="dark"
                :content="scope.row.cabinCleaningTitle"
                placement="top"
              >
                <el-button class="cost-button" style="border: none">
                  <span class="ov-green">{{
                    scope.row.cabinCleaningFeeCompy
                  }}</span>
                  <span
                    v-if="
                      scope.row.cabinCleaningFeeCompy ||
                      scope.row.cabinCleaningFeeCompy == '0'
                    "
                    >/</span
                  ><span class="ov-orange">{{
                    scope.row.cabinCleaningFeeLabor
                  }}</span>
                  <span
                    v-if="
                      scope.row.cabinCleaningFeeLabor ||
                      scope.row.cabinCleaningFeeLabor == '0'
                    "
                    >/</span
                  ><span>{{ scope.row.cabinCleaningFeeInit }}</span>
                </el-button>
              </el-tooltip>
              <div v-if="type == '2'">
                <el-input
                  @change="moneyChange(scope.row)"
                  v-model="scope.row.cabinCleaningFee"
                  oninput="value=value.replace(/^\./g, '').replace(/[^\d.]/g,'').replace(/\.{2,}/g,'')"
                  size="mini"
                  class="cost-input"
                  placeholder="请输入"
                ></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="voyageFee" label="航次费" min-width="100">
            <template slot-scope="scope">
              <el-tooltip
                v-if="type == '1'"
                popper-class="center"
                effect="dark"
                :content="scope.row.voyageTitle"
                placement="top"
              >
                <el-button class="cost-button" style="border: none">
                  <span class="ov-green">{{ scope.row.voyageFeeCompy }}</span>
                  <span
                    v-if="
                      scope.row.voyageFeeCompy ||
                      scope.row.voyageFeeCompy == '0'
                    "
                    >/</span
                  ><span class="ov-orange">{{ scope.row.voyageFeeLabor }}</span>
                  <span
                    v-if="
                      scope.row.voyageFeeLabor ||
                      scope.row.voyageFeeLabor == '0'
                    "
                    >/</span
                  ><span>{{ scope.row.voyageFeeInit }}</span>
                </el-button>
              </el-tooltip>
              <div v-if="type == '2'">
                <el-input
                  @change="moneyChange(scope.row)"
                  v-model="scope.row.voyageFee"
                  oninput="value=value.replace(/^\./g, '').replace(/[^\d.]/g,'').replace(/\.{2,}/g,'')"
                  size="mini"
                  class="cost-input"
                  placeholder="请输入"
                ></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="constantFee" label="常数费" min-width="100">
            <template slot-scope="scope">
              <el-tooltip
                v-if="type == '1'"
                popper-class="center"
                effect="dark"
                :content="scope.row.constantTitle"
                placement="top"
              >
                <el-button class="cost-button" style="border: none">
                  <span class="ov-green">{{ scope.row.constantFeeCompy }}</span>
                  <span
                    v-if="
                      scope.row.constantFeeCompy ||
                      scope.row.constantFeeCompy == '0'
                    "
                    >/</span
                  ><span class="ov-orange">{{
                    scope.row.constantFeeLabor
                  }}</span>
                  <span
                    v-if="
                      scope.row.constantFeeLabor ||
                      scope.row.constantFeeLabor == '0'
                    "
                    >/</span
                  ><span>{{ scope.row.constantFeeInit }}</span>
                </el-button>
              </el-tooltip>
              <div v-if="type == '2'">
                <el-input
                  @change="moneyChange(scope.row)"
                  v-model="scope.row.constantFee"
                  oninput="value=value.replace(/^\./g, '').replace(/[^\d.]/g,'').replace(/\.{2,}/g,'')"
                  size="mini"
                  class="cost-input"
                  placeholder="请输入"
                ></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="businessFee" label="业务费" min-width="100">
            <template slot-scope="scope">
              <el-tooltip
                v-if="type == '1'"
                popper-class="center"
                effect="dark"
                :content="scope.row.businessTitle"
                placement="top"
              >
                <el-button class="cost-button" style="border: none">
                  <span class="ov-green">{{ scope.row.businessFeeCompy }}</span>
                  <span
                    v-if="
                      scope.row.businessFeeCompy ||
                      scope.row.businessFeeCompy == '0'
                    "
                    >/</span
                  ><span class="ov-orange">{{
                    scope.row.businessFeeLabor
                  }}</span>
                  <span
                    v-if="
                      scope.row.businessFeeLabor ||
                      scope.row.businessFeeLabor == '0'
                    "
                    >/</span
                  ><span>{{ scope.row.businessFeeInit }}</span>
                </el-button>
              </el-tooltip>
              <div v-if="type == '2'">
                <el-input
                  @change="moneyChange(scope.row)"
                  v-model="scope.row.businessFee"
                  oninput="value=value.replace(/^\./g, '').replace(/[^\d.]/g,'').replace(/\.{2,}/g,'')"
                  size="mini"
                  class="cost-input"
                  placeholder="请输入"
                ></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="additionalBusinessFee"
            label="额外业务费"
            min-width="100"
          >
            <template slot-scope="scope">
              <el-tooltip
                v-if="type == '1'"
                popper-class="center"
                effect="dark"
                :content="scope.row.additionalBusinessTitle"
                placement="top"
              >
                <el-button class="cost-button" style="border: none">
                  <span class="ov-green">{{
                    scope.row.additionalBusinessFeeCompy
                  }}</span>
                  <span
                    v-if="
                      scope.row.additionalBusinessFeeCompy ||
                      scope.row.additionalBusinessFeeCompy == '0'
                    "
                    >/</span
                  ><span class="ov-orange">{{
                    scope.row.additionalBusinessFeeLabor
                  }}</span>
                  <span
                    v-if="
                      scope.row.additionalBusinessFeeLabor ||
                      scope.row.additionalBusinessFeeLabor == '0'
                    "
                    >/</span
                  ><span>{{ scope.row.additionalBusinessFeeInit }}</span>
                </el-button>
              </el-tooltip>
              <div v-if="type == '2'">
                <el-input
                  @change="moneyChange(scope.row)"
                  v-model="scope.row.additionalBusinessFee"
                  oninput="value=value.replace(/^\./g, '').replace(/[^\d.]/g,'').replace(/\.{2,}/g,'')"
                  size="mini"
                  class="cost-input"
                  placeholder="请输入"
                ></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="tugboatFee" label="拖轮费">
            <template slot-scope="scope">
              <el-tooltip
                v-if="type == '1'"
                popper-class="center"
                effect="dark"
                :content="scope.row.tugboatFeeTitle"
                placement="top"
              >
                <el-button class="cost-button" style="border: none">
                  <span class="ov-green">{{ scope.row.tugboatFeeCompy }}</span>
                  <span
                    v-if="
                      scope.row.tugboatFeeCompy ||
                      scope.row.tugboatFeeCompy == '0'
                    "
                    >/</span
                  ><span class="ov-orange">{{
                    scope.row.tugboatFeeLabor
                  }}</span>
                  <span
                    v-if="
                      scope.row.tugboatFeeLabor ||
                      scope.row.tugboatFeeLabor == '0'
                    "
                    >/</span
                  ><span>{{ scope.row.tugboatFeeInit }}</span>
                </el-button>
              </el-tooltip>
              <div v-if="type == '2'">
                <el-tooltip
                  v-if="
                    scope.row.tugboatFeeLabor ||
                    scope.row.tugboatFeeLabor == '0'
                  "
                  popper-class="center"
                  effect="dark"
                  :content="scope.row.tugboatFeeTitle"
                  placement="top"
                >
                  <el-input
                    @change="moneyChange(scope.row)"
                    v-model="scope.row.tugboatFee"
                    oninput="value=value.replace(/^\./g, '').replace(/[^\d.]/g,'').replace(/\.{2,}/g,'')"
                    size="mini"
                    class="cost-input red-input"
                    placeholder="请输入"
                  ></el-input>
                </el-tooltip>
                <el-input
                  @change="moneyChange(scope.row)"
                  v-if="
                    !scope.row.tugboatFeeLabor &&
                    scope.row.tugboatFeeLabor != '0'
                  "
                  v-model="scope.row.tugboatFee"
                  oninput="value=value.replace(/^\./g, '').replace(/[^\d.]/g,'').replace(/\.{2,}/g,'')"
                  size="mini"
                  class="cost-input"
                  placeholder="请输入"
                ></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="lclHandlingCnyFee" label="外贸散货业务费">
            <template slot-scope="scope">
              <el-tooltip
                v-if="type == '1'"
                popper-class="center"
                effect="dark"
                :content="scope.row.lclHandlingCnyFeeTitle"
                placement="top"
              >
                <el-button class="cost-button" style="border: none">
                  <span class="ov-green">{{
                    scope.row.lclHandlingCnyFeeCompy
                  }}</span>
                  <span
                    v-if="
                      scope.row.lclHandlingCnyFeeCompy ||
                      scope.row.lclHandlingCnyFeeCompy == '0'
                    "
                    >/</span
                  ><span class="ov-orange">{{
                    scope.row.lclHandlingCnyFeeLabor
                  }}</span>
                  <span
                    v-if="
                      scope.row.lclHandlingCnyFeeLabor ||
                      scope.row.lclHandlingCnyFeeLabor == '0'
                    "
                    >/</span
                  ><span>{{ scope.row.lclHandlingCnyFeeInit }}</span>
                </el-button>
              </el-tooltip>
              <div v-if="type == '2'">
                <el-tooltip
                  v-if="
                    scope.row.lclHandlingCnyFeeLabor ||
                    scope.row.lclHandlingCnyFeeLabor == '0'
                  "
                  popper-class="center"
                  effect="dark"
                  :content="scope.row.lclHandlingCnyFeeTitle"
                  placement="top"
                >
                  <el-input
                    @change="moneyChange(scope.row)"
                    v-model="scope.row.lclHandlingCnyFee"
                    oninput="value=value.replace(/^\./g, '').replace(/[^\d.]/g,'').replace(/\.{2,}/g,'')"
                    size="mini"
                    class="cost-input red-input"
                    placeholder="请输入"
                  ></el-input>
                </el-tooltip>
                <el-input
                  @change="moneyChange(scope.row)"
                  v-if="
                    !scope.row.lclHandlingCnyFeeLabor &&
                    scope.row.lclHandlingCnyFeeLabor != '0'
                  "
                  v-model="scope.row.lclHandlingCnyFee"
                  oninput="value=value.replace(/^\./g, '').replace(/[^\d.]/g,'').replace(/\.{2,}/g,'')"
                  size="mini"
                  class="cost-input"
                  placeholder="请输入"
                ></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="cnySubTotal"
            label="人民币小计"
            min-width="180"
          >
            <template slot-scope="scope">
              <el-tooltip
                v-if="type == '1'"
                popper-class="center"
                effect="dark"
                :content="scope.row.cnySubTotalTitle"
                placement="top"
              >
                <el-button class="cost-button flow-button" style="border: none">
                  <span class="ov-green">{{ scope.row.cnySubTotalCompy }}</span>
                  <span
                    v-if="
                      scope.row.cnySubTotalCompy ||
                      scope.row.cnySubTotalCompy == '0'
                    "
                    >/</span
                  ><span class="ov-orange">{{
                    scope.row.cnySubTotalLabor
                  }}</span>
                  <span
                    v-if="
                      scope.row.cnySubTotalLabor ||
                      scope.row.cnySubTotalLabor == '0'
                    "
                    >/</span
                  ><span>{{ scope.row.cnySubTotalInit }}</span>
                </el-button>
              </el-tooltip>
              <span v-if="type == '2'">{{ scope.row.cnySubTotal }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="allCount" label="劳务费用合计" min-width="180">
            <template slot-scope="scope">
              <el-tooltip
                v-if="type == '1'"
                popper-class="center"
                effect="dark"
                :content="scope.row.allCountTitle"
                placement="top"
              >
                <el-button class="cost-button flow-button" style="border: none">
                  <span class="ov-green">{{ scope.row.allCountCompy }}</span>
                  <span
                    v-if="
                      scope.row.allCountCompy || scope.row.allCountCompy == '0'
                    "
                    >/</span
                  ><span class="ov-orange">{{ scope.row.allCountLabor }}</span>
                  <span
                    v-if="
                      scope.row.allCountLabor || scope.row.allCountLabor == '0'
                    "
                    >/</span
                  ><span>{{ scope.row.allCountInit }}</span>
                </el-button>
              </el-tooltip>
              <span v-if="type == '2'">{{ scope.row.allCount }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="outsourcingLaborTotal"
            label="劳务船员劳务费用"
            min-width="180"
          >
            <template slot-scope="scope">
              <el-tooltip
                v-if="type == '1'"
                popper-class="center"
                effect="dark"
                :content="scope.row.outsourcingLaborTotalTitle"
                placement="top"
              >
                <el-button class="cost-button flow-button" style="border: none">
                  <span class="ov-green">{{
                    scope.row.outsourcingLaborTotalCompy
                  }}</span>
                  <span
                    v-if="
                      scope.row.outsourcingLaborTotalCompy ||
                      scope.row.outsourcingLaborTotalCompy == '0'
                    "
                    >/</span
                  ><span class="ov-orange">{{
                    scope.row.outsourcingLaborTotalLabor
                  }}</span>
                  <span
                    v-if="
                      scope.row.outsourcingLaborTotalLabor ||
                      scope.row.outsourcingLaborTotalLabor == '0'
                    "
                    >/</span
                  ><span>{{ scope.row.outsourcingLaborTotalInit }}</span>
                </el-button>
              </el-tooltip>
              <span v-if="type == '2'">{{
                scope.row.outsourcingLaborTotal
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="ownerLaborTotal"
            label="自有船员工资合计"
            min-width="180"
          >
            <template slot-scope="scope">
              <el-tooltip
                v-if="type == '1'"
                popper-class="center"
                effect="dark"
                :content="scope.row.ownerLaborTotalTitle"
                placement="top"
              >
                <el-button class="cost-button flow-button" style="border: none">
                  <span class="ov-green">{{
                    scope.row.ownerLaborTotalCompy
                  }}</span>
                  <span
                    v-if="
                      scope.row.ownerLaborTotalCompy ||
                      scope.row.ownerLaborTotalCompy == '0'
                    "
                    >/</span
                  ><span class="ov-orange">{{
                    scope.row.ownerLaborTotalLabor
                  }}</span>
                  <span
                    v-if="
                      scope.row.ownerLaborTotalLabor ||
                      scope.row.ownerLaborTotalLabor == '0'
                    "
                    >/</span
                  ><span>{{ scope.row.ownerLaborTotalInit }}</span>
                </el-button>
              </el-tooltip>
              <span v-if="type == '2'">{{ scope.row.ownerLaborTotal }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="chdLaborTotal"
            label="船货代船员工资合计"
            min-width="180"
          >
            <template slot-scope="scope">
              <el-tooltip
                v-if="type == '1'"
                popper-class="center"
                effect="dark"
                :content="scope.row.chdLaborTotalTitle"
                placement="top"
              >
                <el-button class="cost-button flow-button" style="border: none">
                  <span class="ov-green">{{
                    scope.row.chdLaborTotalCompy
                  }}</span>
                  <span
                    v-if="
                      scope.row.chdLaborTotalCompy ||
                      scope.row.chdLaborTotalCompy == '0'
                    "
                    >/</span
                  ><span class="ov-orange">{{
                    scope.row.chdLaborTotalLabor
                  }}</span>
                  <span
                    v-if="
                      scope.row.chdLaborTotalLabor ||
                      scope.row.chdLaborTotalLabor == '0'
                    "
                    >/</span
                  ><span>{{ scope.row.chdLaborTotalInit }}</span>
                </el-button>
              </el-tooltip>
              <span v-if="type == '2'">{{ scope.row.chdLaborTotal }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div
        class="other-crew-base"
        style="margin-top: 15px; margin-bottom: 15px; margin-left: 15px"
      >
        <div class="other-base-title">
          <span class="other-base-ball"></span>
          船舶汇总表
        </div>
      </div>
      <div class="other-table-num other-labTale">
        <el-table
          :data="labTable"
          style="width: 100%"
          header-row-class-name="other-header"
          row-class-name="other-row"
          height="100%"
        >
          <el-table-column
            prop="shipName"
            label="船舶名称"
            min-width="100"
            fixed
          >
          </el-table-column>
          <el-table-column prop="month" label="费用月份" min-width="100" fixed>
          </el-table-column>
          <el-table-column
            prop="overLimitContainerFee"
            label="冷、危、超 限箱费"
            min-width="100"
          >
          </el-table-column>
          <el-table-column
            prop="terminalSelfGuidedFee"
            label="自引航费"
            min-width="100"
          >
          </el-table-column>
          <el-table-column prop="berthingFee" label="靠离泊费" min-width="100">
          </el-table-column>
          <el-table-column
            prop="inlandSeaNavigationFee"
            label="内海航行"
            min-width="100"
          >
          </el-table-column>
          <el-table-column prop="serviceFee" label="业务费" min-width="100">
          </el-table-column>
          <el-table-column
            prop="cabinCleaningFeeDollar"
            label="洗舱费"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="voyageFeeDollar"
            label="航次费"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="constantFeeDollar"
            label="常数费"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="lclHandlingUsdFee"
            label="外贸散货业务费"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="antiPiracyBonus"
            label="防海盗奖励"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column prop="usdcny" label="美元汇率" min-width="100">
          </el-table-column>
          <el-table-column
            prop="selfRepairMaintenanceFee"
            label="自修保养费"
            min-width="100"
          >
          </el-table-column>
          <el-table-column prop="checkRewards" label="检查奖励" min-width="100">
          </el-table-column>
          <el-table-column prop="tyingFee" label="绑扎费" min-width="100">
          </el-table-column>
          <el-table-column
            prop="selfPilotingFee"
            label="自引航费"
            min-width="100"
          >
          </el-table-column>
          <el-table-column
            prop="cabinCleaningFee"
            label="洗舱费"
            min-width="100"
          >
          </el-table-column>
          <el-table-column prop="voyageFee" label="航次费" min-width="100">
          </el-table-column>
          <el-table-column prop="constantFee" label="常数费" min-width="100">
          </el-table-column>
          <el-table-column prop="businessFee" label="业务费" min-width="100">
          </el-table-column>
          <el-table-column
            prop="additionalBusinessFee"
            label="额外业务费"
            min-width="100"
          >
          </el-table-column>
          <el-table-column prop="tugboatFee" label="拖轮费" min-width="100">
          </el-table-column>
          <el-table-column
            prop="lclHandlingCnyFee"
            label="外贸散货业务费"
            min-width="100"
          >
          </el-table-column>
          <el-table-column
            prop="shipLaborFeeTotal"
            fixed="right"
            label="劳务费用合计"
            min-width="120"
          >
          </el-table-column>
          <!-- <el-table-column
            prop="inviteTime"
            label="劳务船员劳务费用"
            min-width="100"
          >
          </el-table-column>
          <el-table-column
            prop="inviteTime"
            label="自有船员工资合计"
            min-width="100"
          >
          </el-table-column> -->
          <!-- <el-table-column prop="approveUser" label="核准人" min-width="100">
          </el-table-column>
          <el-table-column prop="approveTime" label="核准日期" min-width="100">
          </el-table-column>
          <el-table-column prop="approveState" label="状态" min-width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.approveState == '1'">待船企核准</span>
              <span v-if="scope.row.approveState == '2'">船船企已审核</span>
              <span v-if="scope.row.approveState == '3'">船企未下发</span>
              <span v-if="scope.row.approveState == '4'">未上报</span>
              <span v-if="scope.row.approveState == '5'">派遣机构待审核</span>
            </template>
          </el-table-column> -->
        </el-table>
      </div>
      <div class="energy-footer cost-footer" v-if="type == '2'">
        <div class="energy-button1" @click="getBack()">返回</div>
        <div class="energy-button2" @click="costSumbit()">制表</div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getLaborUserSettlementList,
  getLaborShipSettlementDetail,
  updateAndApproveLaborShipAndUserSettlement,
} from "@/apis/index";
import { apiJob } from "@/config";
export default {
  data() {
    return {
      formInline: {},
      tableData: [],
      tableData2: [],
      labelVal: "管理费(10%)",
      currentPage1: 1,
      pageNo: "1",
      total: 0,
      pageSize: 1000,
      companyVisible: false,
      jobParams: {},
      remendLoading: false,
      diaList: {},
      rules: {
        userState: [
          {
            required: true,
            message: "请选择员工在本派遣机构状态",
            trigger: "blur",
          },
        ],
      },
      type: "",
      labTable: [],
      labList: {},
    };
  },
  mounted() {
    this.type = this.$route.params.type;
    this.getCrewInfoList();
    this.getLaborShipSettlementDetailList();
  },
  methods: {
    moneyChange(row) {
      row.usdSubTotal = (
        row.overLimitContainerFee * 1 +
        row.terminalSelfGuidedFee * 1 +
        row.berthingFee * 1 +
        row.inlandSeaNavigationFee * 1 +
        row.serviceFee * 1 +
        row.cabinCleaningFeeDollar * 1 +
        row.voyageFeeDollar * 1 +
        row.constantFeeDollar * 1 +
        row.lclHandlingUsdFee * 1 +
        row.antiPiracyBonus * 1
      ).toFixed(2);
      row.cnySubTotal = (
        row.selfRepairMaintenanceFee * 1 +
        row.checkRewards * 1 +
        row.tyingFee * 1 +
        row.selfPilotingFee * 1 +
        row.cabinCleaningFee * 1 +
        row.voyageFee * 1 +
        row.constantFee * 1 +
        row.businessFee * 1 +
        row.additionalBusinessFee * 1 +
        row.tugboatFee * 1 +
        row.lclHandlingCnyFee * 1
      ).toFixed(2);
      if (row.crewType == "1") {
        row.ownerLaborTotal = (
          row.cnySubTotal * 1 +
          row.usdSubTotal * row.usdcny
        ).toFixed(2);
      } else if (row.crewType == "2") {
        row.outsourcingLaborTotal = (
          row.cnySubTotal * 1 +
          row.usdSubTotal * row.usdcny
        ).toFixed(2);
      } else if (row.crewType == "3") {
        row.chdLaborTotal = (
          row.cnySubTotal * 1 +
          row.usdSubTotal * row.usdcny
        ).toFixed(2);
      }
      row.allCount = (
        row.ownerLaborTotal * 1 +
        row.outsourcingLaborTotal * 1 +
        row.chdLaborTotal * 1
      ).toFixed(2);
    },
    changeType(item){
      if(item.crewType == '1'){
        item.outsourcingLaborTotal = 0;
        item.chdLaborTotal = 0;
        this.moneyChange(item);
      }else if (item.crewType == '2'){
        item.ownerLaborTotal = 0;
        item.chdLaborTotal = 0;
        this.moneyChange(item);
      }else if(item.crewType == '3'){
        item.ownerLaborTotal = 0;
        item.outsourcingLaborTotal = 0;
        this.moneyChange(item);
      }
    },
    exportExcel() {
      // await exportEnergyExcel({
      //   specialEnergySavingShipId: this.$route.params.id,
      // });
      window.open(
        `${apiJob}//exportLaborUserSettlementList/exportExcel?token=${sessionStorage.getItem(
          "agenToken"
        )}&laborShipSettlementId=${this.$route.params.id || ""}&userName=${
          this.formInline.userName || ""
        }&postName=${this.formInline.postName || ""}`
      );
    },
    onSubmit() {
      this.pageNo = 1;
      this.getCrewInfoList();
    },
    handleOpen() {},
    handleSizeChange(val) {
      this.pageSize = val;
      this.getCrewInfoList();
      // console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getCrewInfoList();
      // console.log(`当前页: ${val}`);
    },
    choseCom() {
      this.companyVisible = true;
    },
    async getLaborShipSettlementDetailList() {
      let res = await getLaborShipSettlementDetail({
        shipSettlementShipId: this.$route.params.id,
      });
      console.log(res);
      this.labTable = [];
      this.labList = res.data;
      this.labTable = [{ ...res.data }];
    },
    async getCrewInfoList() {
      let res = await getLaborUserSettlementList({
        pageSize: this.pageSize,
        pageNo: this.pageNo,
        laborShipSettlementId: this.$route.params.id,
        ...this.formInline,
      });
      res.data.resultList.forEach((item) => {
        item.overLimitContainerTitle = `航运企业:${
          item.overLimitContainerFeeCompy
            ? item.overLimitContainerFeeCompy
            : item.overLimitContainerFeeCompy == "0"
            ? item.overLimitContainerFeeCompy
            : ""
        };派遣机构:${
          item.overLimitContainerFeeLabor
            ? item.overLimitContainerFeeLabor
            : item.overLimitContainerFeeLabor == "0"
            ? item.overLimitContainerFeeLabor
            : ""
        };初始数据:${item.overLimitContainerFeeInit};`;
        item.cabinCleaningFeeDollarTitle = `航运企业:${
          item.cabinCleaningFeeDollarCompy
            ? item.cabinCleaningFeeDollarCompy
            : item.cabinCleaningFeeDollarCompy == "0"
            ? item.cabinCleaningFeeDollarCompy
            : ""
        };派遣机构:${
          item.cabinCleaningFeeDollarLabor
            ? item.cabinCleaningFeeDollarLabor
            : item.cabinCleaningFeeDollarLabor == "0"
            ? item.cabinCleaningFeeDollarLabor
            : ""
        };初始数据:${item.cabinCleaningFeeDollarInit};`;
        item.voyageFeeDollarTitle = `航运企业:${
          item.voyageFeeDollarCompy
            ? item.voyageFeeDollarCompy
            : item.voyageFeeDollarCompy == "0"
            ? item.voyageFeeDollarCompy
            : ""
        };派遣机构:${
          item.voyageFeeDollarLabor
            ? item.voyageFeeDollarLabor
            : item.voyageFeeDollarLabor == "0"
            ? item.voyageFeeDollarLabor
            : ""
        };初始数据:${item.voyageFeeDollarInit};`;
        item.constantFeeDollarTitle = `航运企业:${
          item.constantFeeDollarCompy
            ? item.constantFeeDollarCompy
            : item.constantFeeDollarCompy == "0"
            ? item.constantFeeDollarCompy
            : ""
        };派遣机构:${
          item.constantFeeDollarLabor
            ? item.constantFeeDollarLabor
            : item.constantFeeDollarLabor == "0"
            ? item.constantFeeDollarLabor
            : ""
        };初始数据:${item.constantFeeDollarInit};`;
        item.terminalSelfGuidedTitle = `航运企业:${
          item.terminalSelfGuidedFeeCompy
            ? item.terminalSelfGuidedFeeCompy
            : item.terminalSelfGuidedFeeCompy == "0"
            ? item.terminalSelfGuidedFeeCompy
            : ""
        };派遣机构:${
          item.terminalSelfGuidedFeeLabor
            ? item.terminalSelfGuidedFeeLabor
            : item.terminalSelfGuidedFeeLabor == "0"
            ? item.terminalSelfGuidedFeeLabor
            : ""
        };初始数据:${item.terminalSelfGuidedFeeInit};`;
        item.berthingTitle = `航运企业:${
          item.berthingFeeCompy
            ? item.berthingFeeCompy
            : item.berthingFeeCompy == "0"
            ? item.berthingFeeCompy
            : ""
        };派遣机构:${
          item.berthingFeeLabor
            ? item.berthingFeeLabor
            : item.berthingFeeLabor == "0"
            ? item.berthingFeeLabor
            : ""
        };初始数据:${item.berthingFeeInit};`;
        item.inlandSeaNavigationTitle = `航运企业:${
          item.inlandSeaNavigationFeeCompy
            ? item.inlandSeaNavigationFeeCompy
            : item.inlandSeaNavigationFeeCompy == "0"
            ? item.inlandSeaNavigationFeeCompy
            : ""
        };派遣机构:${
          item.inlandSeaNavigationFeeLabor
            ? item.inlandSeaNavigationFeeLabor
            : item.inlandSeaNavigationFeeLabor == "0"
            ? item.inlandSeaNavigationFeeLabor
            : ""
        };初始数据:${item.inlandSeaNavigationFeeInit};`;
        item.serviceTitle = `航运企业:${
          item.serviceFeeCompy
            ? item.serviceFeeCompy
            : item.serviceFeeCompy == "0"
            ? item.serviceFeeCompy
            : ""
        };派遣机构:${
          item.serviceFeeLabor
            ? item.serviceFeeLabor
            : item.serviceFeeLabor == "0"
            ? item.serviceFeeLabor
            : ""
        };初始数据:${item.serviceFeeInit};`;
        item.usdSubTotalTitle = `航运企业:${
          item.usdSubTotalCompy
            ? item.usdSubTotalCompy
            : item.usdSubTotalCompy == "0"
            ? item.usdSubTotalCompy
            : ""
        };派遣机构:${
          item.usdSubTotalLabor
            ? item.usdSubTotalLabor
            : item.usdSubTotalLabor == "0"
            ? item.usdSubTotalLabor
            : ""
        };初始数据:${item.usdSubTotalInit};`;
        item.selfRepairMaintenanceTitle = `航运企业:${
          item.selfRepairMaintenanceFeeCompy
            ? item.selfRepairMaintenanceFeeCompy
            : item.selfRepairMaintenanceFeeCompy == "0"
            ? item.selfRepairMaintenanceFeeCompy
            : ""
        };派遣机构:${
          item.selfRepairMaintenanceFeeLabor
            ? item.selfRepairMaintenanceFeeLabor
            : item.selfRepairMaintenanceFeeLabor == "0"
            ? item.selfRepairMaintenanceFeeLabor
            : ""
        };初始数据:${item.selfRepairMaintenanceFeeInit};`;
        item.checkRewardsTitle = `航运企业:${
          item.checkRewardsCompy
            ? item.checkRewardsCompy
            : item.checkRewardsCompy == "0"
            ? item.checkRewardsCompy
            : ""
        };派遣机构:${
          item.checkRewardsLabor
            ? item.checkRewardsLabor
            : item.checkRewardsLabor == "0"
            ? item.checkRewardsLabor
            : ""
        };初始数据:${item.checkRewardsInit};`;
        item.tyingFeeTitle = `航运企业:${
          item.tyingFeeCompy
            ? item.tyingFeeCompy
            : item.tyingFeeCompy == "0"
            ? item.tyingFeeCompy
            : ""
        };派遣机构:${
          item.tyingFeeLabor
            ? item.tyingFeeLabor
            : item.tyingFeeLabor == "0"
            ? item.tyingFeeLabor
            : ""
        };初始数据:${item.tyingFeeInit};`;
        item.selfPilotingTitle = `航运企业:${
          item.selfPilotingFeeCompy
            ? item.selfPilotingFeeCompy
            : item.selfPilotingFeeCompy == "0"
            ? item.selfPilotingFeeCompy
            : ""
        };派遣机构:${
          item.selfPilotingFeeLabor
            ? item.selfPilotingFeeLabor
            : item.selfPilotingFeeLabor == "0"
            ? item.selfPilotingFeeLabor
            : ""
        };初始数据:${item.selfPilotingFeeInit};`;
        item.cabinCleaningTitle = `航运企业:${
          item.cabinCleaningFeeCompy
            ? item.cabinCleaningFeeCompy
            : item.cabinCleaningFeeCompy == "0"
            ? item.cabinCleaningFeeCompy
            : ""
        };派遣机构:${
          item.cabinCleaningFeeLabor
            ? item.cabinCleaningFeeLabor
            : item.cabinCleaningFeeLabor == "0"
            ? item.cabinCleaningFeeLabor
            : ""
        };初始数据:${item.cabinCleaningFeeInit};`;
        item.voyageTitle = `航运企业:${
          item.voyageFeeCompy
            ? item.voyageFeeCompy
            : item.voyageFeeCompy == "0"
            ? item.voyageFeeCompy
            : ""
        };派遣机构:${
          item.voyageFeeLabor
            ? item.voyageFeeLabor
            : item.voyageFeeLabor == "0"
            ? item.voyageFeeLabor
            : ""
        };初始数据:${item.voyageFeeInit};`;
        item.constantTitle = `航运企业:${
          item.constantFeeCompy
            ? item.constantFeeCompy
            : item.constantFeeCompy == "0"
            ? item.constantFeeCompy
            : ""
        };派遣机构:${
          item.constantFeeLabor
            ? item.constantFeeLabor
            : item.constantFeeLabor == "0"
            ? item.constantFeeLabor
            : ""
        };初始数据:${item.constantFeeInit};`;
        item.businessTitle = `航运企业:${
          item.businessFeeCompy
            ? item.businessFeeCompy
            : item.businessFeeCompy == "0"
            ? item.businessFeeCompy
            : ""
        };派遣机构:${
          item.businessFeeLabor
            ? item.businessFeeLabor
            : item.businessFeeLabor == "0"
            ? item.businessFeeLabor
            : ""
        };初始数据:${item.businessFeeInit};`;
        item.additionalBusinessTitle = `航运企业:${
          item.additionalBusinessFeeCompy
            ? item.additionalBusinessFeeCompy
            : item.additionalBusinessFeeCompy == "0"
            ? item.additionalBusinessFeeCompy
            : ""
        };派遣机构:${
          item.additionalBusinessFeeLabor
            ? item.additionalBusinessFeeLabor
            : item.additionalBusinessFeeLabor == "0"
            ? item.additionalBusinessFeeLabor
            : ""
        };初始数据:${item.additionalBusinessFeeInit};`;
        item.cnySubTotalTitle = `航运企业:${
          item.cnySubTotalCompy
            ? item.cnySubTotalCompy
            : item.cnySubTotalCompy == "0"
            ? item.cnySubTotalCompy
            : ""
        };派遣机构:${
          item.cnySubTotalLabor
            ? item.cnySubTotalLabor
            : item.cnySubTotalLabor == "0"
            ? item.cnySubTotalLabor
            : ""
        };初始数据:${item.cnySubTotalInit};`;
        item.outsourcingLaborTotalTitle = `航运企业:${
          item.outsourcingLaborTotalCompy
            ? item.outsourcingLaborTotalCompy
            : item.outsourcingLaborTotalCompy == "0"
            ? item.outsourcingLaborTotalCompy
            : ""
        };派遣机构:${
          item.outsourcingLaborTotalLabor
            ? item.outsourcingLaborTotalLabor
            : item.outsourcingLaborTotalLabor == "0"
            ? item.outsourcingLaborTotalLabor
            : ""
        };初始数据:${item.outsourcingLaborTotalInit};`;
        item.ownerLaborTotalTitle = `航运企业:${
          item.ownerLaborTotalCompy
            ? item.ownerLaborTotalCompy
            : item.ownerLaborTotalCompy == "0"
            ? item.ownerLaborTotalCompy
            : ""
        };派遣机构:${
          item.ownerLaborTotalLabor
            ? item.ownerLaborTotalLabor
            : item.ownerLaborTotalLabor == "0"
            ? item.ownerLaborTotalLabor
            : ""
        };初始数据:${item.ownerLaborTotalInit};`;
        item.allCountTitle = `航运企业:${
          item.allCountCompy
            ? item.allCountCompy
            : item.allCountCompy == "0"
            ? item.allCountCompy
            : ""
        };派遣机构:${
          item.allCountLabor
            ? item.allCountLabor
            : item.allCountLabor == "0"
            ? item.allCountLabor
            : ""
        };初始数据:${item.allCountInit};`;
        item.tugboatFeeTitle = `航运企业:${
          item.tugboatFeeCompy
            ? item.tugboatFeeCompy
            : item.tugboatFeeCompy == "0"
            ? item.tugboatFeeCompy
            : ""
        };派遣机构:${
          item.tugboatFeeLabor
            ? item.tugboatFeeLabor
            : item.tugboatFeeLabor == "0"
            ? item.tugboatFeeLabor
            : ""
        };初始数据:${item.tugboatFeeInit};`;
        item.lclHandlingUsdFeeTitle = `航运企业:${
          item.lclHandlingUsdFeeCompy
            ? item.lclHandlingUsdFeeCompy
            : item.lclHandlingUsdFeeCompy == "0"
            ? item.lclHandlingUsdFeeCompy
            : ""
        };派遣机构:${
          item.lclHandlingUsdFeeLabor
            ? item.lclHandlingUsdFeeLabor
            : item.lclHandlingUsdFeeLabor == "0"
            ? item.lclHandlingUsdFeeLabor
            : ""
        };初始数据:${item.lclHandlingUsdFeeInit};`;
        item.lclHandlingCnyFeeTitle = `航运企业:${
          item.lclHandlingCnyFeeCompy
            ? item.lclHandlingCnyFeeCompy
            : item.lclHandlingCnyFeeCompy == "0"
            ? item.lclHandlingCnyFeeCompy
            : ""
        };派遣机构:${
          item.lclHandlingCnyFeeLabor
            ? item.lclHandlingCnyFeeLabor
            : item.lclHandlingCnyFeeLabor == "0"
            ? item.lclHandlingCnyFeeLabor
            : ""
        };初始数据:${item.lclHandlingCnyFeeInit};`;
        item.chdLaborTotalTitle = `航运企业:${
          item.chdLaborTotalCompy
            ? item.chdLaborTotalCompy
            : item.chdLaborTotalCompy == "0"
            ? item.chdLaborTotalCompy
            : ""
        };派遣机构:${
          item.chdLaborTotalLabor
            ? item.chdLaborTotalLabor
            : item.chdLaborTotalLabor == "0"
            ? item.chdLaborTotalLabor
            : ""
        };初始数据:${item.chdLaborTotalInit};`;
        item.antiPiracyBonusTitle = `航运企业:${
          item.antiPiracyBonusCompy
            ? item.antiPiracyBonusCompy
            : item.antiPiracyBonusCompy == "0"
            ? item.antiPiracyBonusCompy
            : ""
        };派遣机构:${
          item.antiPiracyBonusLabor
            ? item.antiPiracyBonusLabor
            : item.antiPiracyBonusLabor == "0"
            ? item.antiPiracyBonusLabor
            : ""
        };初始数据:${item.antiPiracyBonusInit};`;
      });
      this.total = res.data.rowCount;
      this.tableData = res.data.resultList;
      this.$forceUpdate();
    },

    costSumbit() {
      this.$confirm("确定制表吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 执行删除操作
          // this.$message({
          //   message: "删除成功",
          //   type: "success",
          // });
          this.delList();
        })
        .catch(() => {
          // 取消删除操作
          console.log("取消删除");
        });
    },
    async delList() {
      const overLimitContainerFeeTotal = this.tableData.reduce(
        (sum, current) =>
          (sum + current.overLimitContainerFee * 100).toFixed(2) * 1,
        0
      );
      const terminalSelfGuidedFeeTotal = this.tableData.reduce(
        (sum, current) =>
          (sum + current.terminalSelfGuidedFee * 100).toFixed(2) * 1,
        0
      );
      const berthingFeeTotal = this.tableData.reduce(
        (sum, current) => (sum + current.berthingFee * 100).toFixed(2) * 1,
        0
      );
      const inlandSeaNavigationFeeTotal = this.tableData.reduce(
        (sum, current) =>
          (sum + current.inlandSeaNavigationFee * 100).toFixed(2) * 1,
        0
      );
      const serviceFeeTotal = this.tableData.reduce(
        (sum, current) => (sum + current.serviceFee * 100).toFixed(2) * 1,
        0
      );
      const selfRepairMaintenanceFeeTotal = this.tableData.reduce(
        (sum, current) =>
          (sum + current.selfRepairMaintenanceFee * 100).toFixed(2) * 1,
        0
      );
      const checkRewardsTotal = this.tableData.reduce(
        (sum, current) => (sum + current.checkRewards * 100).toFixed(2) * 1,
        0
      );
      const tyingFeeTotal = this.tableData.reduce(
        (sum, current) => (sum + current.tyingFee * 100).toFixed(2) * 1,
        0
      );
      const selfPilotingFeeTotal = this.tableData.reduce(
        (sum, current) => (sum + current.selfPilotingFee * 100).toFixed(2) * 1,
        0
      );
      const cabinCleaningFeeTotal = this.tableData.reduce(
        (sum, current) => (sum + current.cabinCleaningFee * 100).toFixed(2) * 1,
        0
      );
      const voyageFeeTotal = this.tableData.reduce(
        (sum, current) => (sum + current.voyageFee * 100).toFixed(2) * 1,
        0
      );
      const constantFeeTotal = this.tableData.reduce(
        (sum, current) => (sum + current.constantFee * 100).toFixed(2) * 1,
        0
      );
      const businessFeeTotal = this.tableData.reduce(
        (sum, current) => (sum + current.businessFee * 100).toFixed(2) * 1,
        0
      );
      const additionalBusinessFeeTotal = this.tableData.reduce(
        (sum, current) =>
          (sum + current.additionalBusinessFee * 100).toFixed(2) * 1,
        0
      );
      const tugboatFeeTotal = this.tableData.reduce(
        (sum, current) => (sum + current.tugboatFee * 100).toFixed(2) * 1,
        0
      );
      const cabinCleaningFeeDollarTotal = this.tableData.reduce(
        (sum, current) =>
          (sum + current.cabinCleaningFeeDollar * 100).toFixed(2) * 1,
        0
      );
      const voyageFeeDollarTotal = this.tableData.reduce(
        (sum, current) => (sum + current.voyageFeeDollar * 100).toFixed(2) * 1,
        0
      );
      const constantFeeDollarTotal = this.tableData.reduce(
        (sum, current) =>
          (sum + current.constantFeeDollar * 100).toFixed(2) * 1,
        0
      );
      const lclHandlingUsdFeeTotal = this.tableData.reduce(
        (sum, current) =>
          (sum + current.lclHandlingUsdFee * 100).toFixed(2) * 1,
        0
      );
      const antiPiracyBonusTotal = this.tableData.reduce(
        (sum, current) => (sum + current.antiPiracyBonus * 100).toFixed(2) * 1,
        0
      );
      const lclHandlingCnyFeeTotal = this.tableData.reduce(
        (sum, current) =>
          (sum + current.lclHandlingCnyFee * 100).toFixed(2) * 1,
        0
      );
      if (
        this.labList.overLimitContainerFee !=
        overLimitContainerFeeTotal / 100
      ) {
        this.$message({
          message: "冷、危、超 限箱费合有误！",
          type: "error",
        });
        return;
      }
      if (
        this.labList.terminalSelfGuidedFee !=
        terminalSelfGuidedFeeTotal / 100
      ) {
        this.$message({
          message: "自引航费(美元)合有误！",
          type: "error",
        });
        return;
      }
      if (this.labList.berthingFee != berthingFeeTotal / 100) {
        this.$message({
          message: "靠离泊费（美元）合有误！",
          type: "error",
        });
        return;
      }
      if (
        this.labList.inlandSeaNavigationFee !=
        inlandSeaNavigationFeeTotal / 100
      ) {
        this.$message({
          message: "内海航行（美元）合有误！",
          type: "error",
        });
        return;
      }
      if (this.labList.serviceFee != serviceFeeTotal / 100) {
        this.$message({
          message: "业务费（美元）合有误！",
          type: "error",
        });
        return;
      }
      if (
        this.labList.cabinCleaningFeeDollar !=
        cabinCleaningFeeDollarTotal / 100
      ) {
        this.$message({
          message: "洗舱费（美元）合有误！",
          type: "error",
        });
        return;
      }
      if (this.labList.voyageFeeDollar != voyageFeeDollarTotal / 100) {
        this.$message({
          message: "航次费（美元）合有误！",
          type: "error",
        });
        return;
      }
      if (this.labList.constantFeeDollar != constantFeeDollarTotal / 100) {
        this.$message({
          message: "常数费（美元）合有误！",
          type: "error",
        });
        return;
      }
      if (this.labList.lclHandlingUsdFee != lclHandlingUsdFeeTotal / 100) {
        this.$message({
          message: "外贸散货业务费（美元）合有误！",
          type: "error",
        });
        return;
      }
      if (this.labList.antiPiracyBonus != antiPiracyBonusTotal / 100) {
        this.$message({
          message: "防海盗奖励（美元）合有误！",
          type: "error",
        });
        return;
      }
      if (
        this.labList.selfRepairMaintenanceFee !=
        selfRepairMaintenanceFeeTotal / 100
      ) {
        this.$message({
          message: "自修保养费合有误！",
          type: "error",
        });
        return;
      }
      if (this.labList.checkRewards != checkRewardsTotal / 100) {
        this.$message({
          message: "检查奖励合有误！",
          type: "error",
        });
        return;
      }
      if (this.labList.tyingFee != tyingFeeTotal / 100) {
        this.$message({
          message: "绑扎费合有误！",
          type: "error",
        });
        return;
      }
      if (this.labList.selfPilotingFee != selfPilotingFeeTotal / 100) {
        this.$message({
          message: "自引航费(人民币)合有误！",
          type: "error",
        });
        return;
      }
      if (this.labList.cabinCleaningFee != cabinCleaningFeeTotal / 100) {
        this.$message({
          message: "洗舱费（人民币）合有误！",
          type: "error",
        });
        return;
      }
      if (this.labList.voyageFee != voyageFeeTotal / 100) {
        this.$message({
          message: "航次费（人民币）合有误！",
          type: "error",
        });
        return;
      }
      if (this.labList.constantFee != constantFeeTotal / 100) {
        this.$message({
          message: "常数费（人民币）合有误！",
          type: "error",
        });
        return;
      }
      if (this.labList.businessFee != businessFeeTotal / 100) {
        this.$message({
          message: "业务费（人民币）合有误！",
          type: "error",
        });
        return;
      }
      if (
        this.labList.additionalBusinessFee !=
        additionalBusinessFeeTotal / 100
      ) {
        this.$message({
          message: "额外业务费（人民币）合有误！",
          type: "error",
        });
        return;
      }
      if (
        this.labList.tugboatFee &&
        this.labList.tugboatFee != tugboatFeeTotal / 100
      ) {
        this.$message({
          message: "拖轮费(人民币)合有误！",
          type: "error",
        });
        return;
      }
      if (
        this.labList.lclHandlingCnyFee &&
        this.labList.lclHandlingCnyFee != lclHandlingCnyFeeTotal / 100
      ) {
        this.$message({
          message: "外贸散货业务费(人民币)合有误！",
          type: "error",
        });
        return;
      }
      let res = await updateAndApproveLaborShipAndUserSettlement({
        laborShipSettlementId: this.$route.params.id,
        userSettlementUpdateFList: this.tableData,
      });
      // let
      // this.tableData.forEach(item => {

      // })
      // console.log(res);
      if (res.code == "1") {
        this.$message({
          message: "成功",
          type: "success",
        });
        this.$router.go(-1);
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
      }

      // this.getCrewInfoList();
    },
    passInvite(scope) {
      this.jobParams = {};
      this.diaList = scope.row;
      this.companyVisible = true;
    },
    getBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss" scoped>
::-webkit-scrollbar {
  width: 0.5em;
  height: 0.5em;
}

/* 隐藏滚动条轨道 */
::-webkit-scrollbar-track {
  background-color: transparent;
}

/* 隐藏滚动条滑块 */
::-webkit-scrollbar-thumb {
  background-color: transparent;
}
</style>
